module.exports = __webpack_public_path__ + "img/pic_4.28003d42.jpg";